import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../context";

export const Logo = styled.img`
  ${tw`cursor-pointer`}
  width:100px;

  @media screen and (max-width: 600px) {
    width: 100px;
  }
`;

export const NavMenu = styled.ul`
  ${tw`list-none hidden lg:flex items-center lg:gap-5 xl:gap-10 lg:text-base xl:text-base`}
`;

export const NavLinks = styled.li<{ rooTheme?: Theme }>`
  ${tw`hover:text-blue-300 transition-all ease-in-out duration-700 font-[500]`}
  ${({ rooTheme }) => (rooTheme === "dark" ? tw`text-white` : tw`text-black`)}
`;

export const NavContainer = styled.div<{ scrollNavbar?: boolean }>`
  ${tw``}
`;

export const NavContent = styled.div`
  ${tw`flex justify-between items-center`}
`;

export const ButtonContainer = styled.div`
  ${tw`hidden lg:flex items-center`}
`;

export const NavHeader = styled.header<{
  scrollNavbar?: boolean;
  rooTheme?: Theme;
}>`
  ${tw`font-clash sticky top-0 z-20 transition-all ease-in-out duration-500 py-5 lg:py-7`}
  ${({ rooTheme, scrollNavbar }) =>
    rooTheme && scrollNavbar ? tw`shadow-xl` : ``}
  background:${({ rooTheme, scrollNavbar }) =>
    rooTheme === "dark" && scrollNavbar
      ? "rgba(0,0,0,0.95)"
      : rooTheme === "light" && scrollNavbar
      ? "rgba(255, 255, 255, 0.95)"
      : ""};

  backdrop-filter: ${({ rooTheme, scrollNavbar }) =>
    rooTheme === "dark" && scrollNavbar
      ? "blur(4px)"
      : rooTheme === "light" && scrollNavbar
      ? "blur(5px)"
      : ""};
`;

export const MobileContainer = styled.div<{
  click?: boolean;
  rooTheme?: Theme;
  scrollNavbar?: boolean;
}>`
  ${tw`flex flex-col items-center justify-center gap-10 text-center top-[9.7vh] h-[90.3vh] lg:hidden absolute overflow-y-hidden w-full transition-all ease-in-out duration-500 pb-28`};
  ${({ rooTheme }) => (rooTheme ? tw`shadow-2xl` : ``)}
  background: ${({ rooTheme }) =>
    rooTheme === "dark"
      ? "rgba(0, 0, 0, 1)"
      : rooTheme === "light"
      ? "rgba(255, 255, 255,1)"
      : ""};
  left: ${({ click }) => (click ? "0" : "-100%")};
`;

export const MobileIcon = styled.div<{ rooTheme?: Theme }>`
  ${tw`lg:hidden cursor-pointer text-2xl`};
  ${({ rooTheme }) => (rooTheme === "dark" ? tw` text-white` : tw`text-black`)}
`;

export const MobileMenu = styled.ul<{ click?: boolean }>`
  ${tw`list-none flex flex-col gap-10 text-lg`};
`;

export const MobileMenuItem = styled.li<{ click?: boolean; rooTheme?: Theme }>`
  ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`font-[400] text-white` : tw`font-[500] text-black`}

  opacity: 0;
  &:hover {
    transform: rotate(360deg);
    transition: all ease-in-out 700ms;
  }
  animation: ${({ click }) =>
    click === true
      ? "fade 6s normal forwards ease-in-out"
      : "fadeout 6s normal forwards ease-in-out"};

  @keyframes fade {
    0% {
      opacity: 0;
    }

    25% {
      oapcity: 0.3;
    }
    50% {
      opacity: 0.7;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes fadeout {
    100% {
      opacity: 1;
    }

    50% {
      oapcity: 0.5;
    }
    25% {
      opacity: 0.1;
    }

    0% {
      opacity: 10;
    }
  }
`;
